import { cn } from '@simplywallst/ui-core/next';
import LockSolid from '@simplywallst/ui-core/icons/LockSolid';
import CheckSolid from '@simplywallst/ui-core/icons/CheckSolid';

import { pluralise } from '@/utilities/pluralise';

type Props = {
  label: string;
  $selected: boolean;
  excludedHoldingsCount?: null | number;
  holdingsCount?: null | number;
  totalHoldingsCount?: number;
  isPortfolioLimited?: boolean;
};

export const Option = ({
  label,
  $selected,
  excludedHoldingsCount,
  holdingsCount,
  totalHoldingsCount,
  isPortfolioLimited,
}: Props) => (
  <div
    className={cn(
      'grid grid-cols-[36px_1fr] items-start gap-x1',
      isPortfolioLimited ? 'grid-cols-[36px_1fr_36px]' : ''
    )}
  >
    <div className="grid min-h-9 min-w-9 items-start justify-end">
      {$selected && (
        <CheckSolid height="28" width="28" className="-mt-x0_5 fill-chart-01" />
      )}
    </div>
    <div className="grid grid-cols-[1fr]">
      <p className="m-0 truncate pr-x2 text-xs text-legacy-phantom">{label}</p>
      <p className="m-0 truncate text-tiny text-legacy-darkgray">
        {!isPortfolioLimited &&
        excludedHoldingsCount &&
        excludedHoldingsCount > 0
          ? `${holdingsCount} ${pluralise(
              holdingsCount,
              'holding',
              'holdings'
            )}, ${excludedHoldingsCount} excluded`
          : `${totalHoldingsCount} ${pluralise(
              totalHoldingsCount,
              'holding',
              'holdings'
            )}`}
      </p>
    </div>
    {isPortfolioLimited && (
      <div className="grid min-h-9 min-w-9 items-center justify-end">
        <LockSolid
          aria-label="Blocked Portfolio"
          className="-mt-x0_25 fill-chart-05"
        />
      </div>
    )}
  </div>
);
